var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-empty-function */
import mpActual from 'mixpanel-browser';
import { v4 as uuidv4 } from 'uuid';
// let mixpanel: typeof mpActual;
var session_id = uuidv4();
var mixpanel = mpActual;
if (process.env.MIXPANEL_KEY) {
    mixpanel.init(process.env.MIXPANEL_KEY, {
    // track_pageview: false, //typescript doesn't agree that this exists. (from an old version maybe?)
    });
}
else {
    mixpanel.init("sh-fake-mixpanel");
}
mixpanel.register({ session_id: session_id });
export var alias = function (id) {
    mixpanel.alias(id);
};
export var identify = function (id, attributes) {
    mixpanel.identify(id);
    mixpanel.people.set(__assign({ user_id: id }, (attributes !== null && attributes !== void 0 ? attributes : {})));
};
export var time_event = mixpanel.time_event;
// Duplicated in datadog-setup.js
var emailRegex = /email=[^&]*/;
var phoneRegex = /phone_number=[^&]*/;
var countryRegex = /country=[^&]*/;
var sanitizeQuery = function (url) {
    return url
        .replace(new RegExp(emailRegex, 'g'), 'email=REDACTED')
        .replace(new RegExp(phoneRegex, 'g'), 'phone_number=REDACTED')
        .replace(new RegExp(countryRegex, 'g'), 'country=REDACTED');
};
export var track = function (event, config) {
    mixpanel.track(event, __assign(__assign({}, config), { $current_url: sanitizeQuery(window.location.href), 
        //hoping this also cleans intial referrer, need to test
        $referrer: sanitizeQuery(document.referrer) }));
};
export var register = function (config) {
    var options = __assign({ session_id: session_id }, config);
    mixpanel.register(options);
};
export var resetSession = function () {
    mixpanel.reset();
    session_id = uuidv4();
    mixpanel.register({ session_id: session_id });
};
